import {useMutation} from '@github-ui/react-query'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {usePageDataContext} from '@github-ui/pull-request-page-data-tooling/page-data-context'
import {
  fetchWithErrorHandling,
  parseJSONWithBetterErrors,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'

export type CreateStackOrAppendResponse = {
  stackNumber: number
}

/**
 * Creates a new stack from the given pull requests, or appends them onto
 * an existing stack when `stackId` is provided. `pullRequestIds` must be
 * ordered bottom-of-stack first (position ASC).
 */
export function useCreateStackOrAppendMutation() {
  const {basePageDataUrl} = usePageDataContext()
  const url = `${basePageDataUrl}/page_data/${PageData.createStackOrAppend}`

  return useMutation({
    mutationFn: async ({
      pullRequestIds,
      stackId,
    }: {
      pullRequestIds: number[]
      stackId?: number | null
    }): Promise<CreateStackOrAppendResponse> => {
      const response = await fetchWithErrorHandling(url, {
        method: 'POST',
        body: {
          pullRequestIds,
          ...(stackId != null ? {stackId} : {}),
        },
      })
      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json as CreateStackOrAppendResponse
    },
  })
}
